import { WitzoChatElement } from './text-widget/chat-widget';
import { WitzoVoiceChat } from './voice-text-widget/root_widget';
import { WitzoVoice } from './voice-widget/voice_widget';

/**
 * @description retrieve the url added
 * @returns the url for the hook
 */
const retrieveUrl = () => {
  customElements.define('witzo-chat', WitzoChatElement);
  const chatWidget: WitzoChatElement = document.querySelector('witzo-chat') as WitzoChatElement;

  if (chatWidget != null) {
    const url = chatWidget.attributes.getNamedItem('api-url')!.nodeValue;

    const primaryTextNode = chatWidget.attributes.getNamedItem('primary-text');
    const text = primaryTextNode ? primaryTextNode.nodeValue : null;

    const botColorNode = chatWidget.attributes.getNamedItem('bot-color');
    const bot_color = botColorNode ? botColorNode.nodeValue : null;

    const sendColorNode = chatWidget.attributes.getNamedItem('send-color');
    const send_color = sendColorNode ? sendColorNode.nodeValue : null;

    const floatingBtnColorNode = chatWidget.attributes.getNamedItem('floating-btn');
    const floatingBtn = floatingBtnColorNode ? floatingBtnColorNode.nodeValue : null;

    const logoIconNode = chatWidget.attributes.getNamedItem('logo-icon');
    const logoIcon = logoIconNode ? logoIconNode.nodeValue : null;

    const bannerTextNode = chatWidget.attributes.getNamedItem('banner-text');
    const bannerText = bannerTextNode ? bannerTextNode.nodeValue : null;

    const chatHeaderNode = chatWidget.attributes.getNamedItem('banner-color');
    const chatHeader = chatHeaderNode ? chatHeaderNode.nodeValue : null;

    const autoOpenNode = chatWidget.attributes.getNamedItem('auto-open');
    const autoOpen = autoOpenNode ? autoOpenNode.nodeValue : null;

    const userChatColor = chatWidget.attributes.getNamedItem('user-chat-color');
    const userChatColorValue = userChatColor ? userChatColor.nodeValue : null;

    const bannerTextColorNode = chatWidget.attributes.getNamedItem('banner-text-color');
    const bannerTextColor = bannerTextColorNode ? bannerTextColorNode.nodeValue : null;

    const closeButtonColorNode = chatWidget.attributes.getNamedItem('close-button-color');
    const closeButtonColor = closeButtonColorNode ? closeButtonColorNode.nodeValue : null;
    const uniqueIdNode = chatWidget.attributes.getNamedItem('uniqueId');
    const uniqueId = uniqueIdNode ? uniqueIdNode.nodeValue : null;

    const bannerTextParagraphNode = chatWidget.attributes.getNamedItem('banner-text-paragraph');
    const bannerTextParagraph = bannerTextParagraphNode ? bannerTextParagraphNode.nodeValue : null;

    const bannerTextParagraphColorNode = chatWidget.attributes.getNamedItem('banner-text-paragraph-color');
    const bannerTextParagraphColor = bannerTextParagraphColorNode ? bannerTextParagraphColorNode.nodeValue : null;

    chatWidget.chatUrl = url ?? '';
    chatWidget.defaultPrimaryText = text ?? '';
    chatWidget.botBackgroundColor = bot_color ?? '';
    chatWidget.sendBackgroundColor = send_color ?? '';
    chatWidget.floatingButtonColor = floatingBtn ?? '';
    chatWidget.bannerText = bannerText ?? '';
    chatWidget.logoIcon = logoIcon ?? '';
    chatWidget.chatHeader = chatHeader ?? '';
    chatWidget.autoOpen = autoOpen === 'true' ? true : false;
    chatWidget.userChatColor = userChatColorValue ?? '';
    chatWidget.bannerTextColor = bannerTextColor ?? '';
    chatWidget.closeButtonColor = closeButtonColor ?? '';
    chatWidget.uniqueId = uniqueId ?? '';
    chatWidget.bannerTextParagraph = bannerTextParagraph ?? '';
    chatWidget.bannerTextParagraphColor = bannerTextParagraphColor ?? '';
    return;
  }

  customElements.define('witzo-voice', WitzoVoice);
  //if chat widget is added then it will be shown nothing else
  const voiceWidget: WitzoVoice = document.querySelector('witzo-voice') as WitzoVoice;

  if (voiceWidget) {
    const agentId = voiceWidget.attributes.getNamedItem('agent-id')!.nodeValue;
    voiceWidget.assignAgentId = agentId ?? '';
    return;
  }

  customElements.define('witzo-voice-chat', WitzoVoiceChat);

  const voiceChatWidget: WitzoVoiceChat = document.querySelector(
    'witzo-voice-chat'
  ) as WitzoVoiceChat;
  if (voiceChatWidget) {
    const url = voiceChatWidget.attributes.getNamedItem('api-url')!.nodeValue;
    const agentId = voiceChatWidget.attributes.getNamedItem('agent-id')!.nodeValue;

    const primaryTextNode = voiceChatWidget.attributes.getNamedItem('primary-text');
    const text = primaryTextNode ? primaryTextNode.nodeValue : null;

    const botColorNode = voiceChatWidget.attributes.getNamedItem('bot-color');
    const bot_color = botColorNode ? botColorNode.nodeValue : null;

    const sendColorNode = voiceChatWidget.attributes.getNamedItem('send-color');
    const send_color = sendColorNode ? sendColorNode.nodeValue : null;

    const floatingBtnColorNode = voiceChatWidget.attributes.getNamedItem('floating-btn');
    const floatingBtn = floatingBtnColorNode ? floatingBtnColorNode.nodeValue : null;

    const chatVoiceChatColorNode = voiceChatWidget.attributes.getNamedItem('chat-voice-icon-color');
    const chatVoiceChatColor = chatVoiceChatColorNode ? chatVoiceChatColorNode.nodeValue : null;

    const uniqueIdNode = voiceChatWidget.attributes.getNamedItem('unique-id');
    const uniqueId = uniqueIdNode ? uniqueIdNode.nodeValue : null;

    voiceChatWidget.chatInfo = {
      url: url ?? '',
      defaultText: text,
      botColor: bot_color,
      sendColor: send_color,
      floatingBtn: floatingBtn,
      iconColor: chatVoiceChatColor,
      uniqueId: uniqueId,
    };

    const iconColorNode = voiceChatWidget.attributes.getNamedItem('voice-send-button');
    const voiceColor = iconColorNode ? iconColorNode.nodeValue : null;

    voiceChatWidget.voiceInfo = {
      agentId: agentId ?? '',
      iconColor: voiceColor,
    };
    return;
  }
};

retrieveUrl();
